const notResend = email => !email.actionMethod.startsWith('resend_')

export default notResend
